import axios from "axios";
import { useState, useRef } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import Image from "next/image";
import confetti from "canvas-confetti";

const Contact = () => {
    const [values, setValues] = useState({
        name: "",
        email: "",
        message: "",
    });
    const [loading, setLoading] = useState(false);
    const [buttonText, setButtonText] = useState("Say Hello 👋");
    const buttonRef = useRef<HTMLButtonElement | null>(null); // Reference to the button element

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!values.name.trim() || !values.email.trim() || !values.message.trim()) {
            alert("Please fill in all fields!");
            return;
        }

        try {
            setLoading(true);
            const res = await axios.post("/api/mail", {
                name: values.name,
                email: values.email,
                message: values.message,
            });

            if (res.status === 200) {
                setValues({ name: "", email: "", message: "" });
                setButtonText("Message Sent!");


                if (buttonRef.current) {
                    const buttonRect = buttonRef.current.getBoundingClientRect();
                    const buttonCenterX = buttonRect.left + buttonRect.width / 2;
                    const buttonCenterY = buttonRect.top + buttonRect.height / 2;

                    const originX = buttonCenterX / window.innerWidth;
                    const originY = buttonCenterY / window.innerHeight;


                    confetti({
                        particleCount: 150,
                        spread: 60,
                        origin: {
                            x: originX,
                            y: originY,
                        },
                    });
                }

                setTimeout(() => {
                    setButtonText("Say Hello 👋");
                }, 3000);
            } else {
                setButtonText("Something went wrong.");
                setTimeout(() => {
                    setButtonText("Say Hello 👋");
                }, 3000);
            }
        } catch (error) {
            alert("An error occurred.");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setValues((prevInput) => ({
            ...prevInput,
            [e.target.name]: e.target.value || "",
        }));
    };

    return (
        <div id="contact" className="mb-16 mx-4 lg:mx-0">
            <h2 className="text-center text-4xl">Contact Me</h2>

            <div className="w-full lg:w-5/6 2xl:w-3/4 mt-10 md:mt-16 mx-auto flex justify-between rounded-xl">
                <Image
                    unoptimized={true}
                    quality={100}
                    alt="contact"
                    src="/contact.png"
                    className="hidden md:block w-1/2 h-full object-cover"
                    width={1000}
                    height={1000}
                />
                <div className="flex-1">
                    <h3 className="text-2xl">Get in touch</h3>
                    <p className="text-gray-400 mb-4 text-sm md:text-base">
                        My inbox is always open. Whether you have a question or just want to
                        say hello, I will try my best to get back to you!
                    </p>

                    <form
                        onSubmit={handleSubmit}
                        className="flex flex-col gap-4 rounded-xl"
                    >
                        <input
                            onChange={handleChange}
                            required
                            value={values.name}
                            name="name"
                            type="text"
                            placeholder="Full Name *"
                            className="outline-none bg-gray-100 dark:bg-grey-800 placeholder-gray-400 rounded-lg py-3 px-4"
                        />
                        <input
                            onChange={handleChange}
                            required
                            value={values.email}
                            name="email"
                            type="email"
                            placeholder="Email *"
                            className="outline-none bg-gray-100 dark:bg-grey-800 placeholder-gray-400 rounded-lg py-3 px-4"
                        />
                        <textarea
                            onChange={handleChange}
                            required
                            value={values.message}
                            name="message"
                            rows={4}
                            placeholder="Message *"
                            className="outline-none resize-none bg-gray-100 dark:bg-grey-800 placeholder-gray-400 rounded-lg py-3 px-4"
                        />
                        <button
                            ref={buttonRef} // Assign ref to the button
                            disabled={loading}
                            className="px-4 py-2 bg-violet-600 hover:bg-violet-700 transition-colors text-white rounded-lg disabled:cursor-not-allowed self-end"
                        >
                            {loading ? (
                                <span className="flex items-center gap-2">
                                    Sending... <BiLoaderAlt className="animate-spin" />
                                </span>
                            ) : (
                                buttonText
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;
